import React, { useId } from "react";
import styles from "./InfoTooltip.module.scss";
import { CircleQuestionmark } from "../../../assets/icons";

interface InfoTooltipProps {
	title: string;
	description: string;
	className?: string;
}

/**
 * A question-mark icon that reveals a dark tooltip (title + description) below it on
 * hover or keyboard focus. Pure CSS, no positioning library — sits next to a heading.
 */
const InfoTooltip: React.FC<InfoTooltipProps> = ({ title, description, className = "" }) => {
	const tooltipId = useId();
	return (
		<span className={`${styles.wrapper} ${className}`}>
			<button type="button" className={styles.trigger} aria-label={title} aria-describedby={tooltipId}>
				<CircleQuestionmark />
			</button>
			<span role="tooltip" id={tooltipId} className={styles.tooltip}>
				<span className={styles.tooltipTitle}>{title}</span>
				<span className={styles.tooltipDescription}>{description}</span>
			</span>
		</span>
	);
};

export default InfoTooltip;
